import gql from 'graphql-tag';

const PropertiesGeoSearchResponseError = gql`
    fragment PropertiesGeoSearchResponseError on PropertiesSearchResponseError {
        errors {
            message
        }
    }
`;

const PropertiesGeoSearchConnection = gql`
    fragment PropertiesGeoSearchConnection on PropertiesSearchConnection {
        metaData {
            input {
                geoString
                geoIdentifier
            }
        }
    }
`;

const HOUSE_PRICES_LANDING_QUERY = gql`
    query geoSearch($geoString: String) {
        propertiesSearch(
            after: null
            first: 1
            input: { geoString: $geoString }
        ) {
            ...PropertiesGeoSearchConnection
            ...PropertiesGeoSearchResponseError
        }
    }
    ${PropertiesGeoSearchConnection}
    ${PropertiesGeoSearchResponseError}
`;

export default HOUSE_PRICES_LANDING_QUERY;
